<!-- <mat-progress-bar *ngIf="isLoading"
    color="primary"
    mode="indeterminate">
    </mat-progress-bar> -->
    <div id="documentId" style="background-color: #f2f1f1;">
        <div class="doc-modal-title-wrapper">
            <h4 class="title">{{documentData?documentData.hd_msg_title: ''}} (Documentation)</h4>
            <div class="header-actions">
                @if (!fromHome && user_access>=3 && showTabContent == 0) {
                <button
                    class="gtw-web-components gtw-ele a-btn a-btn-secondary a-btn-lg editbutton"
                    (click)="editMode($event)">
                    {{ attachmentList.length>0 ? 'Edit' : 'Create'}}
                </button>
                }
                <button mat-icon-button type="button" aria-label="Close documentation" title="Close" class="close-btn" (click)="cancel()">
                    <mat-icon>close</mat-icon>
                </button>
            </div>
        </div>
        <div class="upload-tabs-wrapper">
            <li (click)="openTab(0)" [class.active]="showTabContent == 0">Documentation</li>
            <li (click)="openTab(1)" [class.active]="showTabContent == 1">Videos</li>
        </div>
        <div class="doc-view-body-wrapper">
            <div *ngIf="!!documentData.hd_body && showTabContent == 0">
                <div class=" doc-view-modal" >
                    <iframe id="frame" sandbox="allow-same-origin allow-scripts" seamless="true" srcdoc="{{documentData?documentData.hd_body: ''}}" 
                    style="width: 100%; height: calc(100vh - 180px);"class="doc-view-body-wrapper"></iframe>
                </div>
            </div>
            <div *ngIf="(isEditorShow && !fromHome) && (showTabContent == 0)">
                <ap-text-editor
                    [styleClass]="'doc-editor'"
                    [style]="'background: white; display: block;'"
                    [(data)]="text1"
                    [config]="screenDocsEditorConfig"
                    (dataChange)="onChange($event)">
                </ap-text-editor>
            </div>
            <div *ngIf="showTabContent == 0 && attachmentList.length==0 && !isEditorShow">
                <p>No help Document. </p>
            </div>
            
            @if (showTabContent == 1) {
               <gtw-screen-videos
                    (cancelDocModal)="cancel()"
                    [from-home]="fromHome"
                    [screen-key]="effectiveScreenKey"
                    [client-key]="effectiveClientKey"
                    [base-url]="effectiveBaseUrl"
                    [user-access]="user_access"></gtw-screen-videos>
            }
        </div>
        <section class=' gtw-web-components upload-doc-actions' *ngIf="isEditorShow && !fromHome && showTabContent == 0">
            <ap-button [btnType]="'primary'" [label]="'Save'" style="margin-right:10px" (onClick)="saveDocument($event,text1)"></ap-button>
            <ap-button [btnType]="'primary'" [label]="'Clear'" style="margin-right:10px" (onClick)="clearContent($event)"></ap-button>
            <ap-button [btnType]="'primary'" [label]="'Delete'" style="margin-right:10px" (onClick)="deleteDoc()"></ap-button>
        </section>
    </div>

  



